export const PAYMENT_METHODS_LOADED = "PAYMENT_METHODS_LOADED";

export const PAYMENT_METHOD_SELECTED = "PAYMENT_METHOD_SELECTED";

export const NEW_CARD_ADDED = "NEW_CARD_ADDED";

export const INVOICES_LOADED = "INVOICES_LOADED";

export const PAYMENT_METHOD_UPDATED = "PAYMENT_METHOD_UPDATED";

export const SET_BILLING_INFORMATION = "SET_BILLING_INFORMATION";

export const SET_TAX_INFO = "SET_TAX_INFO";

export const CUSTOMER_INFO_LOADED = "CUSTOMER_INFO_LOADED";

export const PAYMENT_METHOD_REMOVED = "PAYMENT_METHOD_REMOVED";